import React from 'react';

const IconC = ({ ...styles }) => (
  <svg viewBox="0 0 64 64" version="1.1" {...styles}>
    <g id="logos/c-copy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle" fill="#C5E4F2" x="0" y="0" width="64" height="64"></rect>
      <path
        d="M32.5825545,45 C37.6199377,45 41.0809969,42.0841121 43,38.682243 L38.2367601,36.2176235 C37.4143302,37.6408545 36.1464174,39.8624833 32.9937695,39.8624833 C29.7383178,39.8624833 27.0311526,37.1895861 27.0311526,31.8090788 C27.0311526,27.7129506 29.0872274,24.0333778 32.9937695,24.0333778 C35.4610592,24.0333778 37.6199377,25.9425901 38.1339564,27.7823765 L42.9314642,25.35247 C41.2180685,21.6728972 37.1744548,19 32.7196262,19 C25.8660436,19 21,24.7276368 21,31.9826435 C21,40.2790387 26.1744548,45 32.5825545,45 Z"
        id="C"
        fill="#1A567E"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

export default IconC;
